import { createSlice } from "@reduxjs/toolkit";
import { getAllPharmacy } from "../actions/pharmacy";

const initialState = {
  pharmacy: [],
  totalcount: 0,
}

const pharmacySlice = createSlice({
  name: "pharmacy",
  initialState,

  extraReducers: (builder) => {
    builder.addCase(getAllPharmacy.pending, (state, action) => {
      state.pharmacy = []
    });
    builder.addCase(getAllPharmacy.fulfilled, (state, action) => {
      state.pharmacy = action.payload.data
      // state.totalcount = action.payload.total
    });
  },
  reducers: {
    createRecord: (state, action) => {
      state.pharmacy.unshift(action.payload)
    },
    updateRecord: (state, action) => {
      const getIndex = state.pharmacy.findIndex(item => item.id == action.payload.id)
      state.pharmacy[getIndex] = action.payload;
    },
    deleteRecord: (state, action) => {
      const getIndex = state.pharmacy.findIndex(item => item.id == action.payload.ID)
      state.pharmacy.splice(getIndex, 1)
    },
  },
});
export default pharmacySlice.reducer;

export const { createRecord,updateRecord, deleteRecord } = pharmacySlice.actions;
